export default __webpack_public_path__ + "static/media/testing-4k.22f0b5ba.jpg";